
      import Sortable from "sortablejs";

      export default {
        mounted() {
          this.ensureSortable();
        },
        updated() {
          this.ensureSortable();
        },
        destroyed() {
          if (this.sortable) {
            this.sortable.destroy();
            this.sortable = null;
          }
        },
        ensureSortable() {
          if (this.sortable) return;

          this.sortable = Sortable.create(this.el, {
            animation: 150,
            handle: "[data-sortable-handle]",
            ghostClass: "opacity-0",
            dragClass: "bg-white",
            onEnd: () => this.pushOrder(),
          });
        },
        pushOrder() {
          const order = Array.from(this.el.querySelectorAll("[data-column-key]"))
            .map((el) => el.dataset.columnKey);
          this.pushEventTo(this.el, "reorder_columns", { order });
        },
      };
    